import { cn } from '../../lib/cn';
import type { ReleaseRow } from '../../enterprisedevops/framework';

type Props = { releases?: ReleaseRow[] };

export function ReleaseManagementPanel({ releases = [] }: Props) {
  return (
    <div className="space-y-2">
      {releases.map((r) => (
        <div key={r.version + r.strategy} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{r.version}</p>
              <p className="text-xs text-slate-500">{r.strategy}</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              r.status.includes('stable') || r.status.includes('ready') ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              r.status.includes('canary') ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' :
              'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
            )}>
              {r.status}
            </span>
          </div>
          {r.progress > 0 && (
            <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
              <div className="h-full rounded-full bg-brand-500" style={{ width: `${r.progress}%` }} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
